import React, { useState, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { getMainSliders } from "../../lib/call-api"

import SwiperCore, {
  EffectFade,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper"

import "swiper/swiper-bundle.min.css"
import "./slider.scss"
import SiteContext from "../../context/site-context";

SwiperCore.use([EffectFade, Navigation, Pagination, Scrollbar, A11y, Autoplay])

export default function TopSlider() {
  const [content, setContent] = useState([])
  const { loadingSetState } = React.useContext(SiteContext)

  useEffect(() => {
    getMainSliders().then(responce => {
      //console.log('TopSlider responce', responce);
      if (responce === undefined) {
        setContent([])
      } else if (responce.status !== 200) {
        setContent([])
        console.log("TopSlider statusText", responce.statusText)
      } else {
        setContent(responce.data)
        loadingSetState(prevValues => (
           {...prevValues, mainSliderLoaded: true}
        ))
      }
    })
       .catch(error => {
         console.error('ON getMainSliders', error)
         setContent([])
       })
  }, [])

  return (
    <div className="slider">
      {content === [] ? (
        <p>Error while loading slider...</p>
      ) : (
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          effect="fade"
          navigation
          loop={true}
          speed={1000}
          autoplay={{ delay: 5000 }}
          pagination={{ clickable: true }}
        >
          {content.map((item, index) => (
            <SwiperSlide key={item.id}>
              <div
                className="slider__bg"
                style={{
                  background: `url(${item.image}) no-repeat center center / cover`,
                }}
              >
                <div className="slider__inner">
                  <div className="container">
                    <div className="slider__mask hidden">
                      <div className="title">{item.title}</div>
                      <div
                        className="text"
                        dangerouslySetInnerHTML={{ __html: item.text }}
                      ></div>
                      {item.reference === "" ? (
                        ""
                      ) : (
                        <a className="slider__btn" href={item.reference}>
                          Подробнее
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  )
}
